<div class="TotemWidget card TotemWidgetViaggiareSicuri {{ fullScreen ? 'TotemWidgetViaggiareSicuri--FullScreen' : '' }}">
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (!isLoading && viewData) {
        @if (!fullScreen) {
            @if (displayCountryName || country) {
                <div class="TotemWidgetViaggiareSicuri-Country border-bottom px-3 py-3">
                    <h3 class="mb-0 h4">{{ displayCountryName || country }}</h3>
                </div>
            }
            <div role="list" [attr.aria-label]="'totem-a11y.viaggiare-sicuri-logo' | locTranslate">
                @for (section of viewData.sections; track section.id; let i = $index) {
                    <div class="TotemWidgetViaggiareSicuri-Title {{ i > 0 ? 'border-top' : '' }}" role="listitem">
                        <button type="button" class="btn" (click)="requestFullScreen.emit({ params: i })">
                            <i class="fa-regular fa-lg fa-fw {{ sectionIcons[section.id] }} me-3 text-primary" aria-hidden="true"></i>
                            <span class="text-dark">{{section.titolo}}</span>
                            <i class="fa-regular fa-chevron-right text-muted p-0 ms-2" aria-hidden="true"></i>
                        </button>
                    </div>
                }
            </div>
        }
        @if (fullScreen) {
            <div class="card-body">
                @if (viewData.sections[fullScreenParams]; as section) {
                    <div class="border-bottom">
                        <h4 class="pb-2">
                            <i class="fa-regular fa-lg fa-fw {{ sectionIcons[section.id] }} me-3 text-primary" aria-hidden="true"></i>
                            <span class="text-dark">{{section.titolo}}</span>
                        </h4>
                    </div>
                    <div>
                        @for (node of section.nodi; track node.titolo; let i = $index) {
                            <div class="TotemWidgetViaggiareSicuri-Title {{ i > 0 ? 'border-top' : '' }} {{node.expanded ? 'TotemWidgetViaggiareSicuri-Title--Expanded' : ''}}">
                                <button type="button" class="btn py-2" (click)="node.expanded = !node.expanded" [attr.aria-expanded]="!!node.expanded">
                                    <h5 class="m-0">{{node.titolo}}</h5>
                                    <i class="fa-regular fa-chevron-down text-muted p-0 ms-2" aria-hidden="true"></i>
                                </button>
                            </div>

                            @if (node.expanded) {
                                <div class="TotemWidgetViaggiareSicuri-Content my-2">
                                    <div class="pg-animation-slidedown" [innerHTML]="node.contenuto | safe:'html'"></div>
                                </div>
                            }
                        }
                    </div>
                }
            </div>
        }
    }
</div>
